import React from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen, Printer, Smile, Clock } from 'lucide-react';
export function SolutionSection() {
  const benefits = [{
    icon: BookOpen,
    title: 'Te diga qué dar',
    desc: 'Manuales explicativos claros'
  }, {
    icon: Printer,
    title: 'Te dé las actividades',
    desc: 'Listas para imprimir o proyectar'
  }, {
    icon: Check,
    title: 'Te permita corregir rápido',
    desc: 'Claves de corrección incluidas'
  }, {
    icon: Clock,
    title: 'Te devuelva tiempo',
    desc: 'Y cabeza para descansar'
  }];
  return <section className="py-12 bg-white" data-id="element-147">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-148">
        <div className="text-center mb-16" data-id="element-149">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-150">
            LO QUE REALMENTE NECESITÁS
          </motion.h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-151">
            No necesitás más ideas. No necesitás más PDFs. No necesitás más
            cursos.
            <br data-id="element-152" />
            <span className="font-bold text-blue-600" data-id="element-153">
              Necesitás un motor de clases armado.
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20" data-id="element-154">
          {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-blue-50 p-6 rounded-xl border border-blue-100 text-center hover:shadow-md transition-shadow" data-id="element-155">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm" data-id="element-156">
                <benefit.icon className="w-6 h-6 text-blue-600" data-id="element-157" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-158">{benefit.title}</h3>
              <p className="text-sm text-gray-600" data-id="element-159">{benefit.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-gray-900 text-white rounded-3xl p-8 md:p-12 shadow-2xl overflow-hidden relative" data-id="element-160">
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500 rounded-full filter blur-3xl opacity-20 -translate-y-1/2 translate-x-1/2" data-id="element-161"></div>

          <div className="relative z-10 grid md:grid-cols-2 gap-12 items-center" data-id="element-162">
            <div data-id="element-163">
              <h3 className="text-3xl font-bold mb-6 text-blue-300" data-id="element-164">
                PACK INGLÉS LISTO™
              </h3>
              <p className="text-lg text-gray-300 mb-6" data-id="element-165">
                Es un sistema modular de clases listas por tema gramatical.
              </p>
              <ul className="space-y-4 mb-8" data-id="element-166">
                {['Manual explicativo claro', 'Actividades listas para imprimir', 'Claves de corrección', 'Plantillas editables'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-167">
                    <div className="bg-blue-600 rounded-full p-1" data-id="element-168">
                      <Check className="w-3 h-3 text-white" data-id="element-169" />
                    </div>
                    <span data-id="element-170">{item}</span>
                  </li>)}
              </ul>
              <div className="bg-white/10 p-4 rounded-lg backdrop-blur-sm border border-white/10" data-id="element-171">
                <p className="font-mono text-sm text-blue-200 mb-2" data-id="element-172">
                  SE USA ASÍ:
                </p>
                <div className="flex items-center gap-2 text-sm md:text-base font-bold" data-id="element-173">
                  <span data-id="element-174">Abrís</span> → <span data-id="element-175">Imprimís</span> →{' '}
                  <span data-id="element-176">Das la clase</span> → <span data-id="element-177">Corregís</span>
                </div>
              </div>
            </div>

            <div className="bg-white/5 p-8 rounded-2xl border border-white/10" data-id="element-178">
              <h4 className="text-xl font-bold mb-6 text-center" data-id="element-179">
                CUANDO LO USÁS, PASA ESTO:
              </h4>
              <ul className="space-y-4 flex flex-col items-center" data-id="element-180">
                {['Entrás al aula segura', 'Las clases tienen orden', 'Los alumnos participan más', 'Vos tenés tiempo', 'Tu cabeza descansa'].map((item, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2 + i * 0.1
              }} className="flex items-center justify-center gap-3 bg-gray-800 p-3 rounded-lg w-full max-w-xs text-center" data-id="element-181">
                    <Smile className="w-5 h-5 text-yellow-400 flex-shrink-0" data-id="element-182" />
                    <span data-id="element-183">{item}</span>
                  </motion.li>)}
              </ul>
              <div className="mt-8 text-center" data-id="element-184">
                <p className="text-blue-300 font-medium" data-id="element-185">
                  Y volvés a sentir algo que parecía perdido:
                </p>
                <p className="text-2xl font-bold text-white mt-2" data-id="element-186">
                  👉 TRANQUILIDAD DOCENTE.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}